import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * ModelViewer component
 */
export default class SectionSlices extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slicess',
    refs: ['items[]', 'slicesWrapper'],
    options: {
      top: String,
    },
  };

  /**
   *
   */
  mounted() {
    const shuffledItems = gsap.utils.shuffle(this.$refs.items);
    const startTrigger = this.$options.top ? 'top bottom' : 'top 80%';

    gsap.to(shuffledItems, {
      scaleY: this.$options.top,
      duration: 1,
      stagger: 0.06,
      ease: 'power4.out',
      scrollTrigger: {
        trigger: this.$el,
        start: startTrigger,
        end: '+=100% top',
        scrub: 1,
      },
    });
  }
}
